import { DataTypeEnum } from "../../enums/DataTypeEnum";
import { AggregateType, ColumnType, DateRangeType, TimeframeType } from "../../enums/DRCXEnums";
import { NumericalFunctionEnum } from "../../enums/NumericalFunctionEnum";

export function makeTatTypeColumnEquatableKey(
    tatTypeID: number,
    dataType: DataTypeEnum,
    groupingTimeframe: TimeframeType,
    groupingFunction?: NumericalFunctionEnum,
    aggregationType?: AggregateType,
    aggregationPeriod?: number,
    aggregationFunction?: number,
    aggregationStepDateRange?: DateRangeType,
    aggregationStep?: number
): string {
    return groupingTimeframe === TimeframeType.Hourly ||
        groupingTimeframe === TimeframeType.Daily ||
        groupingTimeframe === TimeframeType.Weekly ||
        groupingTimeframe === TimeframeType.Monthly ||
        groupingTimeframe === TimeframeType.Yearly
        ? `${ColumnType.TatType}:${typeof tatTypeID === "number" ? tatTypeID : ""}:${typeof dataType === "number" ? dataType : ""}:${typeof groupingTimeframe === "number" ? groupingTimeframe : ""}:${typeof groupingFunction === "number" ? groupingFunction : "0"}:${typeof aggregationType === "number" ? aggregationType : "0"}:${typeof aggregationPeriod === "number" ? aggregationPeriod : "0"}:${typeof aggregationFunction === "number" ? aggregationFunction : "0"}:${typeof aggregationStepDateRange === "number" ? aggregationStepDateRange : ""}:${typeof aggregationStep === "number" ? aggregationStep : ""}`
        : `${ColumnType.TatType}:${typeof tatTypeID === "number" ? tatTypeID : ""}:${typeof dataType === "number" ? dataType : ""}:${typeof groupingTimeframe === "number" ? groupingTimeframe : ""}`;
}
